import { z } from 'zod';
import { validatedGet, validatedPost } from '../api-client.ts';
import { TerritorioSchema, EsitoAggiornamentoTerritoriSchema } from '@/types/entities/territorio.ts';

const ListaResult = z.object({ territori: z.array(TerritorioSchema) });

/** Coppie territorio / cassa edile di Fenice, in sola lettura (punto 7) */
export const territoriApi = {
  lista: () => validatedGet('territori', ListaResult),

  /** Solo amministratore; 502 con messaggio se Fenice non risponde */
  aggiorna: () => validatedPost('territori/aggiorna', {}, EsitoAggiornamentoTerritoriSchema),
};
